// extracted by mini-css-extract-plugin
export default {"main":"u8M13aUO--App_main__AIONN","header":"u8M13aUO--App_header__hFaQY","banner":"u8M13aUO--App_banner__tOMgp"};